import { useMutation, useQueryClient } from "@tanstack/react-query";

import { usersQueryKey } from "@/hooks/queries/useGetUsers";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, User } from "@/types";

export function useDeleteRemoveUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const path = `/users/${id.toString()}`;
      const res = await guacHttpClient.delete<User, HttpResponse<User>>(path);
      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(usersQueryKey(), (cachedData?: User[]) => {
        if (!cachedData) return cachedData;
        return cachedData.filter((user) => user.id !== variables.id);
      });
    },
  });
}
